import * as React from 'react'
import classnames from 'classnames'
import bind from 'bind-decorator'
import { Link } from 'react-router-dom'
import { Grid } from '../../../components/grid'
import { Hamburger, Icon, logo, search, star } from '../../../components'
import { DictionaryValue } from '../../../components/dictionary-value'
import SubNavWithData from './SubNavWithData'
import './NavBar.scss'
import { enableScroll, disableScroll } from '../../../utilities'
import avatar from '../../../static/images/avatar.png'
import { NotificationsWithData } from './notifications'
import EventType from '../../../models/eventType'

export type FieldProps = {
    isEventRunning: boolean
    isSubmenuOpen: boolean
    isLoggedIn: boolean
    eventType?: EventType | null
}

export type MethodProps = {
    openSubmenu: () => void
    closeSubmenu: () => void
}

type Props = FieldProps & MethodProps

class NavBar extends React.Component<Props> {
    @bind
    toggleMenu() {
        const { openSubmenu, closeSubmenu, isSubmenuOpen } = this.props

        if (isSubmenuOpen) {
            closeSubmenu()
            enableScroll()
        } else {
            openSubmenu()
            disableScroll()
        }
    }

    render() {
        const { isEventRunning, isSubmenuOpen, isLoggedIn, eventType } = this.props

        return (
            <>
                <nav className='nav-bar'>
                    <div className={`nav-bar__body nav-bar__body--${eventType}`}>
                        <Grid>
                            <div className='row'>
                                <div className='col-xs-12 nav-bar__wrapper'>
                                    <div className='nav-bar__left'>
                                        <Hamburger
                                            className='nav-bar__hamburger nav-bar__hamburger--desktop'
                                            isActive={isSubmenuOpen}
                                            animationType={'minus'}
                                            onClick={this.toggleMenu}
                                        />
                                        <Hamburger
                                            className='nav-bar__hamburger nav-bar__hamburger--mobile'
                                            isActive={isSubmenuOpen}
                                            animationType={'arrowalt'}
                                            onClick={this.toggleMenu}
                                        />
                                        <Link to='/' className='nav-bar__home-link'>
                                            <Icon icon={logo} className='nav-bar__logo' />
                                        </Link>
                                    </div>
                                    <div className='nav-bar__right'>
                                        {isEventRunning && (
                                            <Link
                                                to='/search'
                                                className='nav-bar__link nav-bar__link--is-icon nav-bar__link-search'
                                            >
                                                <Icon icon={search} />
                                            </Link>
                                        )}
                                        {isLoggedIn && isEventRunning && <NotificationsWithData />}
                                        {isLoggedIn && isEventRunning && (
                                            <Link
                                                to='/favourite'
                                                className='nav-bar__link nav-bar__link--is-icon nav-bar__link-favourite'
                                            >
                                                <Icon icon={star} />
                                            </Link>
                                        )}
                                        {isLoggedIn ? (
                                            <Link to='/account' className='nav-bar__link nav-bar__link--avatar'>
                                                <img
                                                    src={avatar}
                                                    alt='Account'
                                                    className='nav-bar__avatar'
                                                />
                                            </Link>
                                        ) : (
                                            <>
                                                <Link to='/account?join' className='nav-bar__link-join nav-bar__link'>
                                                    <DictionaryValue token='header.nav.links.join' />
                                                </Link>
                                                <Link to='/account?login' className='nav-bar__link-login nav-bar__link'>
                                                    <DictionaryValue token='header.nav.links.login' />
                                                </Link>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </div>
                    <SubNavWithData />
                </nav>
                <div
                    className={classnames('nav-bar-overlay', { 'nav-bar-overlay--is-active': isSubmenuOpen })}
                    onClick={this.toggleMenu}
                />
            </>
        )
    }
}

export default NavBar
